<template>
  <div>
    <InfoAlert :inline="true" type="news" />
    <TopNewsMenu />
    <CarouselBanner type="news" />
    <div name="grid" class="flex justify-center mx-auto">
      <CategoryDropdownSidebar :type="CATEGORY_TYPE.NEWS" />
      <main class="flex-1 sm:flex-none">
        <NewsFeed :id-category="idCategory" />
      </main>
    </div>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import { CATEGORY_TYPE } from "@utils/constants";
import { ROUTES } from "@utils/routes";
import { sitePages } from "@settings/site-pages.settings";
import CarouselBanner from "@components/common/carousel-banner";
import CategoryDropdownSidebar from "@components/category/category-dropdown-sidebar";
import NewsFeed from "@components/news/news-feed";
import TopNewsMenu from "@components/category/top-news-menu";

definePageMeta({
  layout: 'shop-layout'
});

defineI18nRoute({
  paths: {
    cs: '/novinky/tema/[slug]',
    en: '/news/about/[slug]',
    sk: '/novinky/tema/[slug]',
    pl: '/nowosc/temat/[slug]',
    de: '/nachrichten/thema/[slug]'
  }
});

const config = useRuntimeConfig();
const route = useRoute();
const { t } = useI18n();

const idCategory = parseInt(route.params.slug);
const categories = useCategoryStore();
const category = categories.findNews({ id: idCategory });
const canonical = config.public.appBaseUrl + translatePath(ROUTES.CODE.NEWS_ABOUT, slugify(category?.id, category?.name));
const { title: seoTitle, ogUrl } = useFilterSeoTitle(() => category?.name || t('nav-menu-news'));

useHead({ link: [ { rel: 'canonical', href: canonical } ] });
useSeoMeta({
  title: () => seoTitle.value,
  ogTitle: () => seoTitle.value,
  description: t(sitePages[config.public.layoutDesign].news[0].subheading),
  ogDescription: t(sitePages[config.public.layoutDesign].news[0].subheading),
  ogImage: `${config.public.appBaseUrl}${sitePages[config.public.layoutDesign].news[0].image}`,
  ogType: `${sitePages[config.public.layoutDesign].type}`,
  ogUrl: () => ogUrl.value
});

</script>
